"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextList = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var item_1 = require("./item");
require("./textList.css");
/** The TextList component displays a set of related text-only content. Each list item begins with a bullet, a number a check or cross icon. */
var TextList = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'ul' : _b, _c = _a.size, size = _c === void 0 ? 'normal' : _c, children = _a.children, className = _a.className, _d = _a.dataTest, dataTest = _d === void 0 ? 'textList' : _d, appearance = _a.appearance, _e = _a.isChecked, isChecked = _e === void 0 ? false : _e, bullet = _a.bullet, other = tslib_1.__rest(_a, ["type", "size", "children", "className", "dataTest", "appearance", "isChecked", "bullet"]);
    var bulletType;
    if (isChecked) {
        bulletType = 'checked';
    }
    else if (bullet) {
        bulletType = bullet;
    }
    else {
        type === 'ol' ? (bulletType = 'numbers') : (bulletType = 'default');
    }
    var classes = (0, classnames_1.default)('dsc-textList', size ? "is-".concat(size) : null, bulletType !== 'default' && "is-bullet-".concat(bulletType), appearance && "is-".concat(appearance), className);
    return React.createElement(type, tslib_1.__assign(tslib_1.__assign({}, other), { className: classes, 'data-test': dataTest }), children);
};
exports.TextList = TextList;
exports.TextList.Item = item_1.Item;
exports.TextList.displayName = 'TextList';
exports.default = exports.TextList;
//# sourceMappingURL=textList.js.map